import React from "react";
import { Box } from "@mui/material";
import { ShareActionProvider } from "../contexts/ShareActionContext";
import MortgageCalculator from "../components/tools/MortgageCalculator";

const SharedMortgageCalculatorToolPage: React.FC = () => {
  return (
    <ShareActionProvider>
      <Box sx={{ maxWidth: 1100, mx: "auto", p: { xs: 2, sm: 3 } }}>
        <MortgageCalculator />
      </Box>
    </ShareActionProvider>
  );
};

export default SharedMortgageCalculatorToolPage;
